export default "__VITE_ASSET__BWvGv8rM__"